import { Component, Mixins, Prop, Vue } from 'vue-property-decorator'

import { FileType } from '../../../components/File/types'
import {
  MediaEditorMode,
  MessageEditorWithMediaTab
} from "../../../components/NewMessageEditors/types";
import { SelectOptionData } from '../../../components/Pi/types'
import EditorProps from '../../Editor/mixins/mixins'
import { ButtonsConstructorProps } from '../components/ButtonsConstructor/mixins/mixins'
import { AvailableButtonsTypes, } from '../components/ButtonsConstructor/types'
import MessageSettingsProps from '../components/MessageSettings/mixins/mixins'

@Component
export class DisplayLogicHelper extends Vue {
  isCurrElWidthSmall = false

  calculateIsCurrElWidthSmall(): void {
    this.isCurrElWidthSmall = this.elementWidthLessOrEqualsTo(this.$el as HTMLElement, 480)
  }

  elementWidthLessOrEqualsTo(el: HTMLElement, width: number): boolean {
    return el.offsetWidth <= width
  }

  mounted(): void {
    this.calculateIsCurrElWidthSmall()
    window.addEventListener('resize', this.calculateIsCurrElWidthSmall)
  }

  destroyed():void {
    window.removeEventListener('resize', this.calculateIsCurrElWidthSmall)
  }
}

@Component
export class MessageEditorWithMediaProps extends Mixins<EditorProps, MessageSettingsProps, ButtonsConstructorProps>(EditorProps, MessageSettingsProps, ButtonsConstructorProps) {
  @Prop({ type: Array }) declare readonly availableButtonsTypes: AvailableButtonsTypes

  @Prop({
    type: Array,
    default: (): Array<MessageEditorWithMediaTab> => [ MessageEditorWithMediaTab.EditorTab, MessageEditorWithMediaTab.TextareaTab, MessageEditorWithMediaTab.SettingsTab ],
  })
  readonly availableTabs!: Array<MessageEditorWithMediaTab>

  @Prop({ type: Number, default: 12 }) declare readonly buttonsRowsMax: number

  @Prop({ type: Number, default: 8 }) declare readonly buttonsInRowMax: number

  @Prop({ type: Boolean, default: true }) readonly hasMedia!: boolean

  @Prop({ type: Boolean, default: false }) readonly pinMedia !: boolean

  @Prop({ type: Boolean, default: false }) readonly pinButtons !: boolean

  @Prop({ type: Boolean, default: false }) readonly overwriteButton !: boolean

  @Prop({ type: String, required: false }) baseApiUrl!: string

  @Prop({ required: false }) targetToUpload!: (() => { target: string, target_id: string })

  @Prop({ type: Number, default: 10 }) readonly filesToUploadLimit!: number

  @Prop({ default: null }) allDocument!: boolean | null

  @Prop() editorMode!:MediaEditorMode

  @Prop() readonly tariffTags!: any

  @Prop() removeButtonsCallback!: (data: any) => Promise<void>

  @Prop({ type: Number, default: null }) maxMessagesCount!: number

  @Prop({ type: Object }) topics!: { items: Array<SelectOptionData>, limit: number }

  @Prop({ type: Array, default: () => [] }) blacklistMediaButtonTypes!:Array<FileType>
}
